export default __webpack_public_path__ + "static/media/deposit.8e39b14b.gif";